<template>
    <div class="studentMessage">
        <div class="inner">
            <header>
                学生信息普查
            </header>
            <div class="main_box">
                <Title title="学生基本信息"></Title>
                <div class="main">
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">姓名：</span>
                            <span class="detail">{{form.name}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">性别：</span>
                            <span class="detail">{{form.sex==1?'男':'女'}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">民族：</span>
                            <span class="detail">{{form.nation}}</span>
                        </p>
                    </div>

                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">籍贯：</span>
                            <span class="detail">{{form.hometown}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">高考年份：</span>
                            <span class="detail">{{form.gaoYear}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">高考科类：</span>
                            <span class="detail">
                                <span v-for="(item,index) in form.subject">
                                    {{item}}、
                                </span>
                            </span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">出生年月：</span>
                            <span class="detail">{{switchTimeFormat(form.birth)}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">学校：</span>
                            <span class="detail">{{form.school}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">班级：</span>
                            <span class="detail">{{form.class}}</span>
                            <span class="detail">{{form.stressClass===1?"（重点班）":''}}</span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">班级职务：</span>
                            <span class="detail">{{form.classPosition}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">家庭住址：</span>
                            <span class="detail">{{form.homeAddress}}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="main_box">
                <Title title="家庭基本信息"></Title>
                <div class="main">
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">母亲姓名：</span>
                            <span class="detail">{{form.motherName}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">工作单位：</span>
                            <span class="detail">{{form.motherWork}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">职务：</span>
                            <span class="detail">{{form.motherPost}}</span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">学历：</span>
                            <span class="detail">{{form.motherEducation}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">联系方式：</span>
                            <span class="detail">{{form.motherPhone}}</span>
                        </p>
                    </div>

                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">父亲姓名：</span>
                            <span class="detail">{{form.fatherName}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">工作单位：</span>
                            <span class="detail">{{form.fatherWork}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">职务：</span>
                            <span class="detail">{{form.fatherPost}}</span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">学历：</span>
                            <span class="detail">{{form.fatherEducation}}</span>
                        </p>
                        <p class="flex3">
                            <span class="name">联系方式：</span>
                            <span class="detail">{{form.fatherPhone}}</span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p class="flex3">
                            <span class="name">备注：</span>
                            <span class="detail">{{form.remarks}}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="main_box">
                <Title title="学习现状部分"></Title>
                <div class="main">
                    <table class="learning">
                        <thead>
                        <tr>
                            <th>预习情况</th>
                            <th>课堂效果</th>
                            <th>课堂笔记</th>
                            <th>复习情况</th>
                            <th>考试情况</th>
                            <th>学习成绩</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{form.learningPreview}}</td>
                            <td>{{form.learningClass}}</td>
                            <td>{{form.learningNote}}</td>
                            <td>{{form.learningReview}}</td>
                            <td>{{form.learningExam}}</td>
                            <td>{{form.learningGrade}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="learning">
                        <thead>
                        <tr>
                            <th width="170">学科</th>
                            <th>分数</th>
                            <th>年级排名</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(el,index) in form.learningGradeArr" :key="index">
                                <th>{{el.subject}}</th>
                                <td>{{el.grade}}</td>
                                <td>{{el.rank}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="line_flex">
                        <p>我对各学科的喜爱程度：</p>
                        <p>
                            <span v-for="(el,index) in form.learningLikeRank" :key="index"  v-show="el">
                                {{index === 0 ? '': '>'}}
                                {{el}}
                            </span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p>我对各学科的擅长程度：</p>
                        <p>
                            <span v-for="(el,index) in form.learningGoodRank" :key="index" v-show="el">
                                {{index === 0 ? '': '>'}}
                                {{el}}
                            </span>
                        </p>
                    </div>
                    <div class="line_flex">
                        <p>我对各学科教师的喜爱程度：</p>
                        <p>
                            <span v-for="(el,index) in form.learningTeacherRank" :key="index" v-show="el">
                                {{index === 0 ? '': '>'}}
                                {{el}}
                            </span>
                        </p>
                    </div>
                </div>
            </div>


            <div class="main_box">
                <Title title="学习动力部分"></Title>
                <div class="main">
                    <div class="line_box">
                        <p class="title">对我来说，学习过程中的动力有：</p>
                        <p class="detail">{{form.learningPower}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">你喜欢学习吗，在学习过程中你的感受是怎样的：</p>
                        <p class="detail">{{form.learningFeel}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">对我来说，学习过程中的阻碍有：</p>
                        <p class="detail">{{form.learningHinder}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">其中最大的阻碍是：</p>
                        <p class="detail">{{form.learningPower}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">我认为这种阻碍可以解决的程度是：{{form.learningSolveHinder}}</p>
                        <p class="detail">{{form.learningSolveLiyou}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">我认为自己的信息发展潜力如何：{{form.learningPotential}}</p>
                        <p class="detail">{{form.learningPotentialLiyou}}</p>
                    </div>
                </div>
            </div>


            <div class="main_box">
                <Title title="个人信息部分"></Title>
                <div class="main">
                    <p class="line_flex line_input">
                        <span class="name">我参加的社团：</span>
                        <span class="detail">{{form.myClub}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我的兴趣爱好：</span>
                        <span class="detail">{{form.myHobby}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我的特长优势：</span>
                        <span class="detail">{{form.mySpecialty}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我的缺点不足：</span>
                        <span class="detail">{{form.myShortcomings}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我最好的朋友：</span>
                        <span class="detail">{{form.myBestFriend}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">喜欢的书：</span>
                        <span class="detail">{{form.myLikeBook}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">喜欢的电影：</span>
                        <span class="detail">{{form.myLikeMovie}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">喜欢的明星：</span>
                        <span class="detail">{{form.myLikeStar}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我的愿望：</span>
                        <span class="detail">{{form.myWish}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我向往的职业：</span>
                        <span class="detail">{{form.myLikeCareer}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我向往的专业：</span>
                        <span class="detail">{{form.myLikeMajor}}</span>
                    </p>
                    <p class="line_flex line_input">
                        <span class="name">我向往的大学：</span>
                        <span class="detail">{{form.myLikeUniversity}}</span>
                    </p>


                    <div class="line_box">
                        <p class="title">最近做过让自己很有成就感的事：</p>
                        <p class="detail">{{form.myAccomplishment}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">我最近的烦恼：</p>
                        <p class="detail">{{form.myUpset}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">我未来想过的生活：</p>
                        <p class="detail">{{form.myWantLife}}</p>
                    </div>
                </div>
            </div>


            <div class="main_box">
                <Title title="个人成就部分"></Title>
                <div class="main">
                    <div class="line_box">
                        <p class="title">是否曾经获得过市级及以上奖励（如三好学生，优秀干部等）：</p>
                        <template v-if="form.awarded&&form.awarded.length">
                            <div class="line_flex detail"  v-for="(item,index) in form.awarded" :key="index">
                                <p class="flex3">
                                    <span class="name">奖励名称：</span>
                                    <span class="detail">{{item.name}}</span>
                                </p>
                                <p class="flex3">
                                    <span class="name">奖励年份：</span>
                                    <span class="detail">{{item.year}}</span>
                                </p>
                                <p class="flex3">
                                    <span class="name">奖励级别：</span>
                                    <span class="detail">{{item.grade}}</span>
                                </p>
                            </div>
                        </template>
                        <div v-else class="detail">无</div>
                    </div>
                    <div class="line_box">
                        <p class="title">是否对高考统招之外其他路径做过了解并有参与的意愿：</p>
                        <p v-if="form.otherWayList&&form.otherWayList.length"  class="line_flex detail"  >
                            <span v-for="(item,index) in form.otherWayList" :key="index">{{item}}、</span>
                        </p>
                        <div v-else class="detail">无</div>
                    </div>
                </div>
            </div>

            <div class="main_box">
                <Title title="学业规划意愿"></Title>
                <div class="main">
                    <div class="line_box">
                        <p class="title">我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：</p>
                        <p class="detail">{{form.studyWill}}</p>
                    </div>
                </div>
            </div>


            <div class="main_box">
                <Title title="其他部分"></Title>
                <div class="main">
                    <div class="line_box">
                        <p class="title">希望获得哪些方面的帮助：</p>
                        <p class="detail">{{form.otherHelp}}</p>
                    </div>
                    <div class="line_box">
                        <p class="title">其他说明：</p>
                        <p class="detail">{{form.otherDescription}}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Title from '@/components/consultant/MessageTitle.vue'
export default {
    name: "studentMessage",
    props: ['form'],
    components: {
        Title,
    },
    data() {
        return {
            status: 2,
            // form: {
            //     "name": "小欧",
            //     "sex": "1",
            //     "nation": "汉",
            //     "hometown": "山东省济宁市",
            //     "gaoYear": 2021,
            //     "province": "山东",
            //     "subject": ["物理", "化学", "生物"],
            //     "birth": "1995-03-09T16:00:00.000Z",
            //     "school": "第一中学",
            //     "class": "10班",
            //     "stressClass": 1,
            //     "classPosition": "班长",
            //     "inSchool": "1",
            //     "homeAddress": "山东省济宁市兖州区",
            //     "grade": "高二",
            //     "motherName": "母亲姓名",
            //     "motherWork": "母亲工作单位",
            //     "motherPost": "母亲职务",
            //     "motherEducation": "母亲学历",
            //     "motherPhone": "17800279716",
            //     "fatherName": "父亲",
            //     "fatherWork": "父亲工作单位",
            //     "fatherPost": "父亲职务",
            //     "fatherEducation": "父亲学历",
            //     "fatherPhone": "17800279718",
            //     "remarks": "家长基本信息备注",
            //     "learningGoal": "你给自己制定学习目标了吗，如何看待你的目标？：",
            //     "learningTime": "你能自己安排的时间有哪些？比如自习时间，会怎么分配时间？",
            //     "learningPlan": "你有制定学习计划的习惯吗，你会每天制定学习计划吗？",
            //     "learningTrouble": "在记忆和背诵知识点方面你是否存在困扰？具体描述一下你的困扰。",
            //     "learningPreview": "不预习",
            //     "learningClass": "不听课",
            //     "learningNote": "不做笔记",
            //     "learningReview": "不复习",
            //     "learningHomework": "从不",
            //     "learningArrange": "你会定期梳理所学知识，并进行总结和归纳吗，你认为自己的总结归纳能力如何？",
            //     "learningWrong": "你有整理错题的习惯吗？你是如何整理错题的？",
            //     "learningExam": "总紧张",
            //     "learningGrade": "波动大",
            //     "learningLookGoal": null,
            //     "learningTerm": null,
            //     "learningYuekao": null,
            //     "learningYearPeople": "1000",
            //     "learningGradeArr": [{
            //         "subject": "语文",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "数学",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "外语",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "物理",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "化学",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "生物",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "历史",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "政治",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "地理",
            //         "grade": "90",
            //         "rank": "350"
            //     }],
            //     "learningLikeRank": ['外语','政治','数学'],
            //     "learningGoodRank": ['外语','政治','数学'],
            //     "learningTeacherRank": ['外语','政治','数学'],
            //     "learningPower": "对我来说，学习过程中的动力有什么？",
            //     "learningFeel": "你喜欢学习吗，在学习过程中你的感受是怎样的？描述一下你的感受。",
            //     "learningHinder": "对我来说，学习过程中的阻碍有什么：",
            //     "learningMaxHinder": "其中最大的阻碍是：",
            //     "learningSolveHinder": "非常容易",
            //     "learningSolveLiyou": "我认为这种阻碍可以解决的程度是理由",
            //     "learningPotential": "很有潜力",
            //     "learningPotentialLiyou": "我认为自己的信息发展潜力如何：理由",
            //     "myClub": "我参加的社团",
            //     "myHobby": "我的兴趣爱好",
            //     "mySpecialty": "我的特长优势",
            //     "myShortcomings": "我的缺点不足",
            //     "myBestFriend": "我最好的朋友",
            //     "myLikeBook": "喜欢的书",
            //     "myLikeMovie": "喜欢的电影",
            //     "myLikeStar": "喜欢的明星",
            //     "myWish": "我的愿望",
            //     "myLikeCareer": "我向往的职业",
            //     "myLikeMajor": "我向往的专业",
            //     "myLikeUniversity": "我向往的大学：",
            //     "myAccomplishment": "最近做过让自己很有成就感的事：",
            //     "myUpset": "我最近的烦恼：",
            //     "myWantLife": "我未来想过的生活：",
            //     "isAwarded": "有",
            //     "awarded": [{
            //         "key": 1,
            //         "name": "奖励名称：",
            //         "year": 2016,
            //         "grade": "国家级"
            //     }, {
            //         "key": 1,
            //         "name": "奖励名称：",
            //         "year": 2017,
            //         "grade": "省级"
            //     }],
            //     "isWantOtherWay": "有",
            //     "otherWayList": ["强基计划", "综合评价", "高校专项计划"],
            //     "studyWill": "我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：",
            //     "otherHelp": "其他部分：希望获得哪些方面的帮助",
            //     "otherDescription": "其他部分： 其他说明"
            // },
        }
    },
    methods: {
        checkTime(i) {
            if (i < 10) {
                i = '0' + i
            }
            return i
        },
        switchTimeFormat(time) {
            let date = new Date(time);
            return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate())
        }
    },

}
</script>
<style scoped lang="less">
.studentMessage {
    box-sizing: border-box;
    background-color: #fff;
    header {
        height: 153px;
        background: url("~@img/xueyezixun/studentAndParent/header_ques.png") no-repeat center center;
        line-height: 153px;
        color:#0095EB;
        font-size: 40px;
        text-align: center;
        margin-bottom: 30px;
    }

    .main_box {
        padding-bottom: 40px;
        .main {
            font-size: 18px;
            padding-top: 30px;
            table {
                width: 100%;
                text-align: center;
                line-height: 48px;
                margin-bottom: 40px;
                tbody {
                    font-size: 16px;
                }
                tr {
                    th {
                        background: rgba(61, 144, 246, 0.2);
                        border: 1px solid rgba(61, 144, 246, 0.2);
                        text-align: center;
                    }
                    td {
                        border: 1px solid rgba(61, 144, 246, 0.2);
                    }
                }
            }
            .learning {
                width: 100%;
            }
        }
    }
    .line_flex {
        display: flex;
        margin-bottom: 20px;
        font-size: 18px;
        .line_flex_title {
            font-size: 18px;
            line-height: 40px;
        }
        .flex3 {
            line-height: 30px;
            width: 33%;
        }
        .flex1 {
            width: 100%;
        }
        .flex2 {
            width: 50%;
        }
    }
    .line_input {
        .name {
            width: 160px;
        }
        .detail {
            flex: 1;
        }
    }
    .line_box{
        padding-bottom: 20px;
        color: #333;
        .title {
            font-size: 18px;
            line-height: 40px;
        }
        .detail {
            font-size: 16px;
            line-height: 30px;
        }
    }
    .btn_box {
        width: 500px;
        margin: 0 auto;
        padding-top: 40px;
        display: flex;
        justify-content: space-around;
        .go_back {
            font-size: 18px;
            font-weight: 500;
            color: #0095EB;
            padding: 0 30px;
            line-height: 30px;
            cursor: pointer;
            border: 1px solid #000;
            box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.18);
            border-radius: 15px;
            border: 1px solid rgba(0, 149, 235, 0.5);
            &:active {
                box-shadow: none;
            }
        }
        .go_submitbtn {
            font-size: 18px;
            font-weight: 500;
            color: #0095EB;
            min-width: 118px;
            text-align: center;
            border-radius: 15px;
            color: #fff;
            padding: 0 30px;
            line-height: 30px;
            cursor: pointer;
            background: linear-gradient(305deg, #0095EB 0%, #2CB2FF 100%, #2CB2FF 100%);
            box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.4);
            &:active {
                box-shadow: none;
            }
        }
    }


}
</style>